import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {
  private defaultFavicon = 'assets/favicon.ico';
  private faviconLink: HTMLLinkElement | null = null;

  constructor() {
    this.faviconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  }

  changeFavicon(faviconUrl: string) {
    if (this.faviconLink) {
      this.faviconLink.href = faviconUrl;
    } else {
      this.createFaviconLink(faviconUrl);
    }
  }

  private createFaviconLink(faviconUrl: string) {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = faviconUrl;
    document.head.appendChild(link);
    this.faviconLink = link;
  }

  resetFavicon() {
    this.changeFavicon(this.defaultFavicon);
  }
}
